var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#D84022"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8569 9.23492V5.49902L23.9661 10.7385L20.6079 10.9025C19.655 10.949 18.8569 10.189 18.8569 9.23492Z",
    fill: "#D84022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8994 7.63128L18.8994 9.37686C18.8994 10.4148 19.7408 11.2562 20.7788 11.2562H25M25 11.2562L19.0539 5H10.036C8.91153 5 8 5.91153 8 7.03596V15.9286V24.8212C8 25.9456 8.91153 26.8571 10.036 26.8571H22.964C24.0885 26.8571 25 25.9456 25 24.8212L25 11.2562Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 19V14.6364H12.6648C12.9886 14.6364 13.272 14.7003 13.5149 14.8281C13.7578 14.956 13.9467 15.1357 14.0817 15.3672C14.2166 15.5987 14.2841 15.8693 14.2841 16.179C14.2841 16.4915 14.2145 16.7621 14.0753 16.9908C13.9375 17.2195 13.7436 17.3956 13.4936 17.5192C13.245 17.6428 12.9545 17.7045 12.6222 17.7045H11.4972V16.7841H12.3835C12.5227 16.7841 12.6413 16.7599 12.7393 16.7116C12.8388 16.6619 12.9148 16.5916 12.9673 16.5007C13.0213 16.4098 13.0483 16.3026 13.0483 16.179C13.0483 16.054 13.0213 15.9474 12.9673 15.8594C12.9148 15.7699 12.8388 15.7017 12.7393 15.6548C12.6413 15.6065 12.5227 15.5824 12.3835 15.5824H11.9659V19H10.7812ZM16.3977 19H14.7188V14.6364H16.3807C16.8295 14.6364 17.2173 14.7237 17.544 14.8984C17.8722 15.0717 18.125 15.3217 18.3026 15.6484C18.4815 15.9737 18.571 16.3636 18.571 16.8182C18.571 17.2727 18.4822 17.6634 18.3047 17.9901C18.1271 18.3153 17.8757 18.5653 17.5504 18.7401C17.2251 18.9134 16.8409 19 16.3977 19ZM15.9034 17.9943H16.3551C16.571 17.9943 16.755 17.9595 16.907 17.8899C17.0604 17.8203 17.1768 17.7003 17.2564 17.5298C17.3374 17.3594 17.3778 17.1222 17.3778 16.8182C17.3778 16.5142 17.3366 16.277 17.2543 16.1065C17.1733 15.9361 17.054 15.8161 16.8963 15.7464C16.7401 15.6768 16.5483 15.642 16.321 15.642H15.9034V17.9943ZM19.1191 19V14.6364H22.1873V15.5909H20.3038V16.3409H21.9998V17.2955H20.3038V19H19.1191Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.865a3200bc30063c4ee8bba51bed9169.svg";
export { ForwardRef as ReactComponent };